import { render, staticRenderFns } from "./press-card.vue?vue&type=template&id=1492b21a"
import script from "./press-card.vue?vue&type=script&lang=js"
export * from "./press-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports